import React, { useEffect, useState } from "react";
import { StyleSheet, View, StatusBar } from "react-native";
import { STYLES } from "../../assets/styles";
import CustomIcon from "../../components/CustomIcon";
import Forgot from "../../components/Forgot";
import Loading from "../../components/Loading";

function ForgotPassword({ navigation }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    StatusBar.setBarStyle("dark-content");
    return () => {
      StatusBar.setBarStyle("light-content");
    };
  }, []);

  return (
    <View style={{ flex: 1, backgroundColor: STYLES.colors.white }}>
      <View
        style={{
          padding: 10,
          paddingTop: StatusBar.currentHeight,
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <CustomIcon
          type="AntDesign"
          name="left"
          onPress={() => navigation.goBack()}
          style={{
            fontSize: STYLES.fontSizes.xlarge,
            color: STYLES.colors.black,
          }}
        />
      </View>
      <View style={styles.container}>
        <Forgot
          onLoadingChange={setLoading}
          transparent
          onSuccess={() => {
            navigation.navigate("signin");
          }}
        />
      </View>
      {loading ? <Loading spinner /> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default ForgotPassword;
